
// note: if we are changing the value here, we also needed changes from BE.
export const ASS_ASSESSMENT = [
  {
    value: "PHQ 9",
    label: "Patient Health Questionnaire-9",
  },
  {
    value: "GAD 7",
    label: "Generalized Anxiety Disorder 7-item",
  },
  {
    value: "PHQ-4",
    label: "Patient Health Questionnaire 4",
  },
  {
    value: "PHQ 2",
    label: "Patient Health Questionnaire-2",
  },
  {
    value: "GAD-2",
    label: "Generalized Anxiety Disorder 2-item",
  },
  {
    value: "DASS-21",
    label: "Depression Anxiety Stress Scale - 21",
  },
  {
    value: "EPDS",
    label: "Edinburgh Postnatal Depression Scale",
  },
  {
    value: "C-SSRS",
    label: "Columbia Suicide Severity Rating Scale (Full, Modified)",
  },
  {
    value: "ASQ",
    label: "Ask Suicide-Screening Questions",
  },
  {
    value: "SCARED-Child",
    label: "Screen for Child Anxiety Related Disorders",
  },
  {
    value: "RCADS",
    label: "Revised Child Anxiety and Depression Scale",
  },
  {
    value: "PCL-5",
    label: "PTSD Checklist for DSM-5 (weekly version)",
  },
  {
    value: "PC-PTSD-5",
    label: "Primary Care PTSD Screen for DSM-5",
  },
  {
    value: "ACES ",
    label: "Adverse Childhood Experience Questionnaire ",
  },
  {
    value: "AUDIT",
    label: "Alcohol Use Disorders Identification Test",
  },
  {
    value: "ASSIST",
    label:
      "Alcohol, Smoking and Substance Involvement Screening Test - Modified",
  },
  {
    value: "ASRS 1.1",
    label: "Adult ADHD Self-Report Scale V1.1",
  },
  {
    value: "VAS-Parent-Follow-up",
    label: "NICHQ Vanderbilt Assessment Follow-up - Parent Informant ",
  },
  {
    value: "STAI",
    label: "State-Trait Anxiety Inventory",
  },
  {
    value: "WHODAS 2.0 NEW",
    label: "World Health Organization Disability Assessment Schedule 2.0",
  },

  //todo: we are commenting below to show only first 20 assessments.
  // {
  //   value: "VAS-Parent",
  //   label: "NICHQ Vanderbilt Assessment Scale - Parent - Spanish",
  // },
  // {
  //   value: "EXPASS",
  //   label: "Exploitation Assessment 2022",
  // },
  // {
  //   value: "LOCUS",
  //   label: "Level Of Care Utilization System",
  // },
  // {
  //   value: "FLBS",
  //   label: "Friedman Life Balance Scale",
  // },
  // {
  //   value: "UCLA-3 NEW",
  //   label: "UCLA Three-Item Loneliness Scale ",
  // },
  // {
  //   value: "ASRM",
  //   label: "Altman Self-Rating Mania Scale",
  // },
  // {
  //   value: "PAQR",
  //   label: "Patient Adherence to Antidepressant Medication-Revised",
  // },
  // {
  //   value: "STIM",
  //   label: "Stimulant Medication Safety & Effective Use Questionnaire",
  // },
  // {
  //   value: "FIBSER Scale NEW",
  //   label: "Frequency, Intensity, Burden of Side Effects Rating ",
  // },
  // {
  //   value: "Measuring Adverse Events ",
  //   label: "Measuring Adverse Events (adapted from FIBSER)",
  // },
  // {
  //   value: "BSPS",
  //   label: "Be Smart Patient Survey",
  // },
  // {
  //   value: "BSPS-4",
  //   label: "Be Smart Patient Survey-4",
  // },
  // {
  //   value: "CFQ",
  //   label: "Cognitive Failures Questionnaire",
  // },
  // {
  //   value: "AMPS",
  //   label: "Applied Mindfulness Process Scale",
  // },
  // {
  //   value: "FFMQ",
  //   label: "Five Facet Mindfulness Questionnaire",
  // },
  // {
  //   value: "Freiburg Mindfulness Inventory (FMI)",
  //   label: "Freiburg Mindfulness Inventory",
  // },
  // {
  //   value: "KIMS",
  //   label: "Kentucky Inventory of Mindfulness Skills",
  // },
  // {
  //   value: "MQG-Child Long",
  //   label: "Mood and Feelings Questionnaire - Child Long",
  // },
  // {
  //   value: "MFQ-Parent Long",
  //   label: "Mood and Feelings Questionnaire - Parent Long",
  // },
  // {
  //   value: "MFQ-Parent Short",
  //   label: "Mood and Feelings Questionnaire - Parent Short",
  // },
  // {
  //   value: "PSC-35",
  //   label: "Pediatric Symptom Checklist",
  // },
  // {
  // //   value: "PSC-35",
  // //   label: "Pediatric Symptom Checklist",
  // // },
  // {
  //   value: "PSC-35",
  //   label: "Pediatric Symptom Checklist",
  // },
  // {
  //   value: "PSC-17-Parent (New)",
  //   label: "Pediatric Symptom Checklist-17 - Parent ",
  // },
  // {
  //   value: "PSC-17-Spanish",
  //   label: "Pediatric Symptom Checklist 17 - Parent Spanish",
  // },
  // {
  //   value: "PSC-17",
  //   label: "Pediatric Symptom Checklist 17 - Youth Self-Report",
  // },
  // {
  //   value: "PSCC-P-S",
  //   label: "Pediatric Symptom Checklist Parent-Report Spanish",
  // },
  // {
  //   value: "PNSS",
  //   label: "Personal Need for Structure Scale",
  // },
  // {
  //   value: "ANSA",
  //   label: "Adult Needs and Strengths Assessment",
  // },
  // {
  //   value: "CANS-EI",
  //   label: "Child and Adolescent Needs and Strengths",
  // },
  // {
  //   value: "CANAS",
  //   label: "Child and Adolescent Needs and Strength",
  // },
  // {
  //   value: "OCI-4",
  //   label: "Obsessive Compulsive Inventory OCI-4",
  // },
  // {
  //   value: "OCI-12",
  //   label: "Obsessive Compulsive Inventory -12",
  // },
  // {
  //   value: "C-FOCI",
  //   label: "Children's Florida Obsessive Compulsive Inventory",
  // },
  // {
  //   value: "OBQ-44",
  //   label: "Obsessional Beliefs Questionnaire",
  // },
  // {
  //   value: "OCI",
  //   label: "Obsessive-Compulsive Inventory",
  // },
  // {
  //   value: "OCI-CV-R",
  //   label: "Obsessive Compulsive Inventory - Child Version",
  // },
  // {
  //   value: "OCI-R",
  //   label: "Obsessive Compulsive Inventory - Revised",
  // },
  // {
  //   value: "RIASEC",
  //   label: "Holland Code (RIASEC) Test",
  // },
  // {
  //   value: "briefmood-after",
  //   label: "Brief Mood Survey-After Session",
  // },
  // {
  //   value: "briefmood-before",
  //   label: "Brief Mood Survey-Before Session",
  // },
  // {
  //   value: "PNRS",
  //   label: "Pain Numeric Rating Scale",
  // },
  // {
  //   value: "The Pain Catastrophizing Scale",
  //   label: "The Pain Catastrophizing Scale",
  // },
  // {
  //   value: "WHYMPI",
  //   label: "West Haven-Yale Multidimensional Pain Inventory",
  // },
  // {
  //   value: "CPAQ-R",
  //   label: "Chronic Pain Acceptance Questionnaire- Revised",
  // },
  // {
  //   value: "STIC Child Rel",
  //   label: "STIC Relationship with Child Scale",
  // },
  // {
  //   value: "APQ",
  //   label: "The University of New Orleans Alabama Parenting Questionnaire",
  // },
  // {
  //   value: "POPS",
  //   label: "Perception of Police Scale ",
  // },
  // {
  //   value: "OC TRS",
  //   label: "OC Trait Rating Scale",
  // },
  // {
  //   value: "BEST",
  //   label: "Borderline Evaluation of Severity Over Time ",
  // },
  // {
  //   value: "BSL-23",
  //   label: "Borderline Symptom List 23",
  // },
  // {
  //   value: "BSL-23-Full",
  //   label: "Borderline Symptom List 23 + Supplemental (modified)",
  // },
  // {
  //   value: "SAPAS",
  //   label: "Standardized Assessment of Personality - Abbreviated Scale",
  // },
  // {
  //   value: "DPD-Q",
  //   label: "Dependent Personality Disorder Questionnaire",
  // },
  // {
  //   value: "FM5",
  //   label: "Friedman Mini 5 Factor Personality Scale",
  // },
  // {
  //   value: "NPI-13",
  //   label: "The Narcissistic Personality Inventory - 13",
  // },
  // {
  //   value: "NPI-16",
  //   label: "The Narcissistic Personality Inventory - 16",
  // },
  // {
  //   value: "MFPI",
  //   label: "Multidimensional Psychological Flexibility Inventory",
  // },
  // {
  //   value: "MFPI-S",
  //   label: "Multidimensional Psychological Flexibility Inventory - Short ",
  // },
  // {
  //   value: "DPSS, Clinician-Rated",
  //   label: "Clinician-Rated Dimensions of Psychosis Symptom Severity",
  // },
  // {
  //   value: "PQ-B",
  //   label: "Prodromal Questionnaire, Brief Version",
  // },
  // {
  //   value: "Yale-PRIME",
  //   label: "Yale PRIME Early Psychosis Screening Test",
  // },
  // {
  //   value: "CPSS-V - NEW",
  //   label: "Child PTSD Symptom Scale - 5",
  // },
  // {
  //   value: "CRIES-13-1",
  //   label: "Children's Impact of Events Scale",
  // },
  // // {
  // //   value: "CRIES-13-2",
  // //   label: "Children's Impact of Events Scale",
  // // },
  // {
  //   value: "CRIES-13-2",
  //   label: "Children's Impact of Events Scale",
  // },
  // {
  //   value: "TLC PTSD CAQ",
  //   label: "TLC PTSD Child and Adolescent Questionnaire",
  // },
  // {
  //   value: "YCPC",
  //   label: "Young Child PTSD Checklist",
  // },
  // {
  //   value: "BQL",
  //   label: "Bariatric Quality of Life Index",
  // },
  // {
  //   value: "PQ-LES-Q",
  //   label:
  //     "Pediatric Quality of Life Enjoyment and Satisfaction Questionnaire ",
  // },
  // {
  //   value: "ProQOL",
  //   label: "Professional Quality of Life Scale",
  // },
  // {
  //   value: "Q-LES-Q",
  //   label: "Quality of Life Enjoyment and Satisfaction Questionnaire",
  // },
  // {
  //   value: "Q-LES-Q-SF",
  //   label:
  //     "Quality of Life Enjoyment and Satisfaction Questionnaire - Short 14 Items",
  // },
  // {
  //   value: "Q-LES-Q-S",
  //   label:
  //     "Quality of Life Enjoyment and Satisfaction Questionnaire - Short Form",
  // },
  // {
  //   value: "BAT NEW",
  //   label: "Burnout Assessment Tool",
  // },
  // {
  //   value: "RFLS",
  //   label: "Reasons For Living Scale ",
  // },
  // {
  //   value: "RAS",
  //   label: "Recovery Assessment Scale- 20 Item",
  // },
  // {
  //   value: "CSI-16",
  //   label: "Couples Satisfaction Index-16",
  // },
  // {
  //   value: "DAS",
  //   label: "Dyadic Adjustment Scale",
  // },
  // {
  //   value: "ECR-R",
  //   label: "Experiences In Close Relationships-Revised Questionnaire",
  // },
  // {
  //   value: "SSPS",
  //   label: "Social Safeness and Pleasure Scale",
  // },
  // {
  //   value: "CSI",
  //   label: "Couples Satisfaction Index",
  // },
  // {
  //   value: "CSI-4",
  //   label: "Couple Satisfaction Index 4",
  // },
  // {
  //   value: "CIRAA",
  //   label:
  //     "Child Interpersonal Relationship and Attitude Assessment - Parent Report",
  // },
  // {
  //   value: "GIQ",
  //   label: "God Image Questionnaire",
  // },
  // {
  //   value: "Weekly Participation Survey",
  //   label: "Weekly Participation Survey",
  // },
  // // {
  // //   value: "BRCS",
  // //   label: "Brief Resilient Coping Scale",
  // // },
  // {
  //   value: "BRCS",
  //   label: "Brief Resilient Coping Scale",
  // },
  // // {
  // //   value: "BRCS - Spanish",
  // //   label: "Brief Reslient Coping Scale - Spanish",
  // // },
  // {
  //   value: "BRCS - Spanish",
  //   label: "Brief Reslient Coping Scale - Spanish",
  // },
  // {
  //   value: "NMRQ-A",
  //   label: "Nicholson McBride Resilience Questionnaire - Abbreviated",
  // },
  // {
  //   value: "CARE",
  //   label: "Child/Adolescent Pre- and Post-Treatment Risk Evaluation",
  // },
  // {
  //   value: "PSI",
  //   label: "Patient Satisfaction Index",
  // },
  // // {
  // //   value: "Care-F",
  // //   label: "Experience of Our Treatment - Caregiver Perspective",
  // // },
  // {
  //   value: "Care-F",
  //   label: "Experience of Our Treatment - Caregiver Perspective",
  // },
  // {
  //   value: "CSAS-Spanish",
  //   label: "Client Satisfaction Assessment Survey - Spanish Version",
  // },
  // {
  //   value: "CPPSS",
  //   label: "Comprehensive Program Participant Satisfaction Survey (modified)",
  // },
  // {
  //   value: "ITR-CS",
  //   label: "ITR Client Survey",
  // },
  // {
  //   value: "IS",
  //   label: "Identifying Schemas",
  // },
  // {
  //   value: "SCD",
  //   label: "Self Care Diary",
  // },
  // {
  //   value: "SCS-SF NEW",
  //   label: "Self-Compassion Scale, Short Form ",
  // },
  // {
  //   value: "SSCS-S NEW",
  //   label: "The State Self-Compassion Scale, Short Form ",
  // },
  // {
  //   value: "SCS-Y",
  //   label: "Self-Compassion Scale for Youth",
  // },
  // {
  //   value: "SSCS-L",
  //   label: "State Self-Compassion Scale Long Form",
  // },
  // {
  //   value: "GSE",
  //   label: "General Self-Efficacy Scale",
  // },
  // {
  //   value: "ASEQ",
  //   label: "Adolescent Self-Esteem Questionnaire",
  // },
  // {
  //   value: "RSES",
  //   label: "Rosenberg Self-Esteem Scale",
  // },
  // {
  //   value: "NSSI",
  //   label: "Non-Suicidal Self-Injury Questionnaire",
  // },
  // {
  //   value: "ASBI-P",
  //   label: "Adolescent Sexual Behavior Inventory - Parent Report",
  // },
  // {
  //   value: "FSFI",
  //   label: "Female Sexual Function Index",
  // },
  // {
  //   value: "IIEF",
  //   label: "International Index of Erectile Function",
  // },
  // {
  //   value: "MSHQ",
  //   label: "Male Sexual Health Questionnaire",
  // },
  // {
  //   value: "MSHQ-EjD",
  //   label: "Male Sexual Health Questionnaire - Ejaculation Short Form",
  // },
  // {
  //   value: "PREA",
  //   label: "PREA Intake Assessment Tool",
  // },
  // {
  //   value: "PROMIS-Sle",
  //   label: "DSM-5 Level 2 Sleep Disturbance",
  // },
  // {
  //   value: "PROMIS-Sleep-Child",
  //   label: "DSM-5 Level 2 Sleep Disturbance, Child",
  // },
  // {
  //   value: "ISI",
  //   label: "Insomnia Severity Index",
  // },
  // {
  //   value: "DBAS-16 NEWW",
  //   label: "Dysfunctional Beliefs and Attitudes about Sleep",
  // },
  // {
  //   value: "ESS NEW",
  //   label: "Epworth Sleepiness Scale",
  // },
  // {
  //   value: "SDS-CL-25 NEW",
  //   label: "Sleep Disorders Symptoms Checklist-25",
  // },
  // {
  //   value: "DSM-5 SAD New",
  //   label: "DSM-5 Severity Measure for Social Anxiety Disorder",
  // },
  // {
  //   value: "DSM-5 SAD Child",
  //   label:
  //     "Severity Measure for Social Anxiety Disorder (Social Phobia)— Child Age 11–17",
  // },
  // // {
  // //   value: "AHC Health-Related Social.Needs Screener (Adults)",
  // //   label: "Health-Related Social Needs Screening Tool",
  // // },
  // // {
  // //   value: "AHC Health-Related Social.Needs Screener (Adults)",
  // //   label: "Health-Related Social Needs Screening Tool (Core)",
  // // },
  // {
  //   value: "AHC Health-Related Social.Needs Screener (Adults)",
  //   label: "Health-Related Social Needs Screening Tool (Crossroads)",
  // },
  // {
  //   value: "SDOH",
  //   label: "Social Determinants of Health",
  // },
  // {
  //   value: "SRS - 2",
  //   label: "Social Responsiveness Scale - 2",
  // },
  // {
  //   value: "ISEL-12",
  //   label: "Interpersonal Support Evaluation List 12-item Modified Version ",
  // },
  // {
  //   value: "PROMIS-Som",
  //   label: "DSM-5 Level 2 Somatic Symptoms",
  // },
  // {
  //   value: "PHQ-15-Child",
  //   label: "DSM-5 Level 2 Somatic Symptoms, Child",
  // },
  // {
  //   value: "DSM-5 II Som-P (NEW)",
  //   label: "DSM-5 Level 2, Somatic Symptoms, Parent Report ",
  // },
  // {
  //   value: "SSS-8",
  //   label: "Somatic Symptom Scale 8",
  // },
  // {
  //   value: "FSAS",
  //   label: "Friedman Spiritual Awakening Scale",
  // },
  // // {
  // //   value: "SDQ",
  // //   label: "Strengths & Difficulties Questionnaire",
  // // },
  // {
  //   value: "SDQ",
  //   label: "Strengths & Difficulties Questionnaire - Parent",
  // },
  // {
  //   value: "GAS NEW",
  //   label: "Game Addiction Scale",
  // },
  // {
  //   value: "DSM-5 II Sub Use",
  //   label: "DSM-5 Level 2 Substance Use - Adult",
  // },
  // {
  //   value: "TAPS-1",
  //   label:
  //     "TAPS-1 - Tobacco, Alcohol, Prescription medication, and other Substance use Tool",
  // },
  // {
  //   value: "TAPS-2 NEW",
  //   label:
  //     "TAPS-2 - Tobacco, Alcohol, Prescription medication, and other Substance use Tool 2",
  // },
  // {
  //   value: "ASQ-AR",
  //   label: "Ask Suicide Screening Questions with Acute Risk",
  // },
  // {
  //   value: "C-SSRS-B",
  //   label: "Columbia Suicide Severity Rating Scale (Brief)",
  // },
  // {
  //   value: "C-SSRS (new)",
  //   label: "Columbia Suicide Severity Rating Scale (Screen)",
  // },
  // {
  //   value: "C-SSRS-SL",
  //   label:
  //     "Columbia Suicide Severity Rating Scale - Screener Since Last Appointment",
  // },
  // {
  //   value: "OA",
  //   label: "Intuitive -Therapeutic Alliance 5",
  // },
  // {
  //   value: "ARM-5 NEW",
  //   label: "Agnew Relationship Measure-5",
  // },
  // {
  //   value: "ARM-5-T",
  //   label: "Agnew Relationship Measure 5 - Team",
  // },
  // {
  //   value: "CALPAS-Patient-SF",
  //   label:
  //     "California Psychotherapy Alliance Scales - Short Form Patient Version",
  // },
  // {
  //   value: "CHS",
  //   label: "Cultural Humility Scale",
  // },
  // {
  //   value: "ICUA (FI-C)",
  //   label: "Iowa Cultural Understanding Assessment (Couples FI Adaptation)",
  // },
  // {
  //   value: "ICUA (FI-F)",
  //   label: "Iowa Cultural Understanding Assessment (Family FI Adaptation)",
  // },
  // {
  //   value: "ICUA (FI)",
  //   label: "Iowa Cultural Understanding Assessment (FI Adaptation)",
  // },
  // {
  //   value: "ICUA (FI-I)",
  //   label: "Iowa Cultural Understanding Assessment (Individual FI Adaptation)",
  // },
  // {
  //   value: "Mindfuli WAI-SR",
  //   label: "Mindfuli Working Alliance Inventory - Shortform Revised",
  // },
  // {
  //   value: "SAI-Patient",
  //   label: "Session Alliance Inventory (Patient Form)",
  // },
  // {
  //   value: "STIC Couples",
  //   label: "STIC Couples",
  // },
  // {
  //   value: "STIC Family",
  //   label: "STIC Family",
  // },
  // {
  //   value: "STIC Ind",
  //   label: "STIC Systemic Individual",
  // },
  // {
  //   value: "WAI-Best",
  //   label: "Working Alliance Inventory - Best",
  // },
  // {
  //   value: "WAI",
  //   label: "Working Alliance Inventory - Short",
  // },
  // {
  //   value: "SMHAT-1",
  //   label: "SMHAT-1 Athletes (Form 1)",
  // },
  // {
  //   value: "SMHAT-2",
  //   label: "SMHAT- 1 Athletes (Form 2)",
  // },
  // {
  //   value: "SMHAT-3",
  //   label: "SMHAT-1 Athletes (Form 3)",
  // },
  // {
  //   value: "CATS-Parent (3-6)",
  //   label: "Child and Adolescent Trauma Screen - Caregiver Report (3-6)",
  // },
  // {
  //   value: "CATS-Parent",
  //   label: "Child and Adolescent Trauma Screen - Caregiver Report (7-17)",
  // },
  // {
  //   value: "CATS-Parent-3-6-Spanish",
  //   label:
  //     "Child and Adolescent Trauma Screen - Parent-Report 3-6 years - Spanish",
  // },
  // {
  //   value: "CATS-Parent-7-17-Spanish",
  //   label:
  //     "Child and Adolescent Trauma Screen - Parent-Report 7-17 years - Spanish",
  // },
  // // {
  // //   value: "CATS-Parent",
  // //   label:
  // //     "Child and Adolescent Trauma Screen Progress Monitoring - Parent Report",
  // // },
  // {
  //   value: "CATS Progress-Youth",
  //   label:
  //     "Child and Adolescent Trauma Screen Progress Monitoring Youth Report",
  // },
  // {
  //   value: "CATS/Self Report(7-17)",
  //   label: "Child and Adolescent Trauma Screen/Self Report (Ages 7-17 years)",
  // },
  // {
  //   value: "CATS-Youth",
  //   label: "Child and Adolescent Trauma Screen - Youth Report",
  // },
  // {
  //   value: "CATS-Child-Spanish",
  //   label: "Child and Adolescent Trauma Screen - Youth-Report - Spanish",
  // },
  // {
  //   value: "CRIES-13",
  //   label: "Children's Impact of Events Scale",
  // },
  // {
  //   value: "DSM-5 SMAS-C",
  //   label: "DSM-5 Severity Measure for Acute Stress, Child",
  // },
  // {
  //   value: "DSM-5 SMPTSD-C",
  //   label: "DSM-5 Severity Measure for PTSD, Child",
  // },
  // {
  //   value: "IES-1",
  //   label: "Impact of Events Scale-1",
  // },
  // // {
  // //   value: "IES-1",
  // //   label: "Impact of Events Scale-2",
  // // },
  // // {
  // //   value: "IES-2",
  // //   label: "Impact of Events Scale-2",
  // // },
  // {
  //   value: "IES-3",
  //   label: "Impact of Events Scale-3",
  // },
  // {
  //   value: "IES-R",
  //   label: "Impact of Events Scale- Revised",
  // },
  // {
  //   value: "ITQ",
  //   label: "International Trauma Questionnaire",
  // },
  // {
  //   value: "LSC-R",
  //   label: "Life Stressor Checklist - Revised",
  // },
  // {
  //   value: "PTSST",
  //   label: "Pediatric Trauma Stress Screening Tool",
  // },
  // {
  //   value: "PTSST-P",
  //   label: "Pediatric Trauma Stress Screening Tool - Parent",
  // },
  // {
  //   value: "P-ACES",
  //   label: "Philadelphia Adverse Child Experiences (ACES)",
  // },
  // // {
  // //   value: "PCL-5",
  // //   label: "PTSD Checklist for DSM-5 (monthly version)",
  // // },
  // {
  //   value: "PCL-5 - Spanish",
  //   label: "PTSD Checklist for DSM-5 - Spanish",
  // },
  // {
  //   value: "PCL-5+LEC",
  //   label: "PTSD Checklist for DSM-5 with Life Events Checklist",
  // },
  // {
  //   value: "THS",
  //   label: "Trauma History Screen",
  // },
  // {
  //   value: "TRS",
  //   label: "Trauma Recovery Scale",
  // },
  // // {
  // //   value: "THQ",
  // //   label: "Trauma History Questionnaire ",
  // // },
  // {
  //   value: "THQ",
  //   label: "Trauma History Questionnaire ",
  // },
  // {
  //   value: "PTGI NEW",
  //   label: "Post Traumatic Growth Inventory",
  // },
  // {
  //   value: "LEC-5",
  //   label: "Life Events Checklist",
  // },
  // {
  //   value: "TRS-CA",
  //   label: "Trauma Recovery Scale- Children and Adolescents",
  // },
  // {
  //   value: "MGH-Hair Pulling",
  //   label: "Massachusetts General Hospital Hair Pulling Scale",
  // },
  // {
  //   value: "VQ NEW",
  //   label: "Valuing Questionnaire ",
  // },
  // {
  //   value: "AWS",
  //   label: "Adolescent Wellbeing Scale",
  // },
  // {
  //   value: "CSAQ",
  //   label: "Caregiver Self-Assessment Questionnaire",
  // },
  // {
  //   value: "PWI-A",
  //   label: "Personal Wellbeing Index - Adult-5",
  // },
  // {
  //   value: "PWI-SC",
  //   label: "Personal Wellbeing Index - School Children/Adolescents",
  // },
  // {
  //   value: "WEMWBS",
  //   label: "Warwick–Edinburgh Mental Well-being Scale",
  // },
  // {
  //   value: "WHO-5",
  //   label: "Wellbeing-Index 5",
  // },
  // {
  //   value: "WA-A",
  //   label: "Wellness Assessment - Adult (modified)",
  // },
  // {
  //   value: "WA-Y",
  //   label: "Wellness Assessment - Youth (modified)",
  // },
  // {
  //   value: "CompAct",
  //   label:
  //     "Comprehensive Assessment of Acceptance and Commitment Therapy Processes",
  // },
  // {
  //   value: "CompACT- MOD",
  //   label:
  //     "Comprehensive Assessment of Acceptance and Commitment Therapy Processes - Modified",
  // },
  // {
  //   value: "ACT-Adv",
  //   label: "The ACT Advisor",
  // },
  // {
  //   value: "ADL-FA",
  //   label: "ADL Functional Assessment Form",
  // },
  // {
  //   value: "DLA-20 Self-Report",
  //   label: "Daily Living Activities-20, Self-Report",
  // },
  // {
  //   value: "AAQ-II",
  //   label: "Acceptance and Action Questionnaire-II",
  // },
  // {
  //   value: "AWARE 3.0",
  //   label: "Advance Warning of Relapse 3.0",
  // },
  // {
  //   value: "AUDIT-C",
  //   label: "Alcohol Use Disorder Identification Test - Consumption",
  // },
  // {
  //   value: "BARC-10",
  //   label: "Brief Assessment of Recovery Capital",
  // },
  // {
  //   value: "BTS",
  //   label: "Brief Tobacco Screen",
  // },
  // {
  //   value: "DSM5-SU-Child",
  //   label: "DSM-5 Level 2 Substance Use, Child",
  // },
  // {
  //   value: "UUS",
  //   label: "Urge to Use Scale",
  // },
  // {
  //   value: "SOGS",
  //   label: "South Oaks Gambling Screen",
  // },
  // // {
  // //   value: "CIAS",
  // //   label: "Chen Internet Addiction Scale",
  // // },
  // {
  //   value: "CIAS",
  //   label: "Chen Internet Addiction Scale",
  // },
  // {
  //   value: "LASA",
  //   label: "Love Addiction Self-Assessment",
  // },
  // {
  //   value: "PPCS-S",
  //   label: "Problematic Pornography Consumption Scale, Short",
  // },
  // {
  //   value: "SAST",
  //   label: "The Sexual Addiction Screening Test",
  // },
  // {
  //   value: "ASRS-v1.1 Part A",
  //   label: "Adult ADHD Self-Report Scale  V1.1 Part A (Screen)",
  // },
  // {
  //   value: "ADHD-SS",
  //   label: "Child ADHD Symptom Scale",
  // },
  // {
  //   value: "VAS-Parent-Follow-up-Spanish",
  //   label: "NICHQ Vanderbilt Assessment Follow-up - Parent Informant-Spanish ",
  // },
  // // {
  // //   value: "VAS-Parent",
  // //   label: "NICHQ Vanderbilt Assessment Scale - Parent",
  // // },
  // {
  //   value: "VAS-Parent",
  //   label: "NICHQ Vanderbilt Assessment Scale - Parent - Spanish",
  // },
  // {
  //   value: "VAS-Teacher",
  //   label: "NICHQ Vanderbilt Assessment Scale - Teacher",
  // },
  // {
  //   value: "PSC-P-A",
  //   label: "Pediatric Symptom Checklist-Parent Report, Attention Subscale",
  // },
  // {
  //   value: "PSC-Y-A",
  //   label: "Pediatric Symptom Checklist Youth Self-Report - Attention Subscale",
  // },
  // {
  //   value: "WURS-25",
  //   label: "Wender Utah Rating Scale 25",
  // },
  // {
  //   value: "ADNM-8",
  //   label: "Adjustment Disorder - New Module 8",
  // },
  // {
  //   value: "ADNM-8 Stressors",
  //   label: "Adjustment Disorder - New Module 8 Life Stressor Screening",
  // },
  // {
  //   value: "FAS-N",
  //   label: "Friedman Affect Scale - Negative",
  // },
  // {
  //   value: "FAS-P",
  //   label: "Friedman Affect Scale - Positive",
  // },
  // {
  //   value: "FAS-S",
  //   label: "Friedman Affect Scale Short Form",
  // },
  // {
  //   value: "PANAS-SF",
  //   label: "Positive and Negative Affect Schedule - Short",
  // },
  // {
  //   value: "PANAS-X",
  //   label: "Positive and Negative Affect Schedule X",
  // },
  // {
  //   value: "MOAS NEW",
  //   label: "Modified Overt Aggression Scale",
  // },
  // {
  //   value: "BAM (NEW)",
  //   label: "Brief Addiction Monitor ",
  // },
  // {
  //   value: "LDQ - NEW",
  //   label: "Leeds Dependence Questionnaire ",
  // },
  // {
  //   value: "MAST",
  //   label: "Michigan Alcohol Screening Test",
  // },
  // {
  //   value: "TAS",
  //   label: "Toronto Alexithymia Scale",
  // },
  // {
  //   value: "ARI",
  //   label: "Affective Reactivity Index",
  // },
  // {
  //   value: "PROMIS-Ang",
  //   label: "DSM-5 Level 2 Anger",
  // },
  // {
  //   value: "PROMIS-Ang-Child",
  //   label: "DSM-5 Level 2 Anger, Child",
  // },
  // {
  //   value: "DSM-5 II Ang-P",
  //   label: "DSM-5 Level 2 Anger, Parent Report",
  // },
  // {
  //   value: "DSM-5 II Irr-P",
  //   label: "DSM-5 Level 2 Irritability, Parent Report",
  // },
  // {
  //   value: "DSM-5 II Anx-P (GN)",
  //   label: "DSM-5 Level 2 Anxiety, Parent Report (Gender Neutral Language)",
  // },
  // {
  //   value: "HAM-A",
  //   label: "Hamilton Anxiety Rating Scale (Clinician Administered)",
  // },
  // {
  //   value: "OASIS",
  //   label: "Overall Anxiety Severity and Impairment Scale ",
  // },
  // {
  //   value: "PASS",
  //   label: "Perinatal Anxiety Screening Scale",
  // },
  // {
  //   value: "PROMIS Pediatric Anxiety-SF",
  //   label: "PROMIS Pediatric Anxiety - Short Form 8a V2",
  // },
  // {
  //   value: "SCARED-Child-Spanish",
  //   label: "Screen for Child Anxiety Related Disorders - Child - Spanish",
  // },
  // {
  //   value: "SCARED - Parent",
  //   label: "Screen for Child Anxiety Related Disorders - Parent",
  // },
  // {
  //   value: "SCARED-Parent-Spanish",
  //   label: "Screen for Child Anxiety Related Disorders - Parent - Spanish",
  // },
  // {
  //   value: "SCAS-Child-Spanish",
  //   label: "Spence Children's Anxiety Scale - Child - Spanish",
  // },
  // {
  //   value: "SCAS-Parent-Spanish",
  //   label: "Spence Children's Anxiety Scale - Parent - Spanish",
  // },
  // {
  //   value: "SCAS-Preschool-Spanish",
  //   label: "Spence Children's Anxiety Scale - Preschool - Spanish",
  // },
  // {
  //   value: "DSM-5 Agoraphobia",
  //   label: "DSM-5 Severity Measure for Agoraphobia-Adult",
  // },
  // {
  //   value: "RCADS-P",
  //   label: "Revised Child Anxiety and Depression Scale - Caregiver",
  // },
  // {
  //   value: "ALSS",
  //   label: "Athletes' Life Stress Scale",
  // },
  // {
  //   value: "AAI",
  //   label: "Appearance Anxiety Inventory",
  // },
  // {
  //   value: "FASA",
  //   label: "Family Accomodation Scale-Anxiety",
  // },
  // {
  //   value: "DSM-5 Anx-C",
  //   label: "DSM-5 Level 2 Anxiety, Child 11-17",
  // },
  // {
  //   value: "DSM-5 II Anx-P ",
  //   label: "DSM-5 Level 2 Anxiety, Parent Report (old)",
  // },
  // {
  //   value: "DSM-5 GAD-C",
  //   label: "DSM-5 Severity Measure for Generalized Anxiety Disorder, Child",
  // },
  // {
  //   value: "GAD-7 + Impairment",
  //   label: "Generalized Anxiety Disorder 7-item + Functional Impairment",
  // },
  // {
  //   value: "GAD-7 (Spanish)",
  //   label: "Generalized Anxiety Disorder 7-item - Spanish",
  // },
  // {
  //   value: "HAI",
  //   label: "Health Anxiety Inventory",
  // },
  // {
  //   value: "SIR",
  //   label: "Savings Inventory-Revised",
  // },
  // {
  //   value: "SMPD",
  //   label: "Severity Measure for Panic Disorder",
  // },
  // // {
  // //   value: "PSS",
  // //   label: "Parental Stress Scale",
  // // },
  // // {
  // //   value: "PSS",
  // //   label: "Parental Stress Scale",
  // // },
  // // {
  // //   value: "PSS",
  // //   label: "Parental Stress Scale",
  // // },
  // // {
  // //   value: "PSS",
  // //   label: "Parental Stress Scale",
  // // },
  // // {
  // //   value: "PSS",
  // //   label: "Parental Stress Scale",
  // // },
  // // {
  // //   value: "PSS",
  // //   label: "Parental Stress Scale",
  // // },
  // // {
  // //   value: "PAS-P",
  // //   label: "Preschool  Anxiety Scale - Parent",
  // // },
  // {
  //   value: "PAS-P",
  //   label: "Preschool  Anxiety Scale - Parent",
  // },
  // {
  //   value: "BFNE-II",
  //   label: "Brief Fear of Negative Evaluation-II",
  // },
  // {
  //   value: "SIAS",
  //   label: "Social Interaction Anxiety Scale",
  // },
  // {
  //   value: "SPS",
  //   label: "Social Phobia Scale",
  // },
  // {
  //   value: "SMSP",
  //   label: "DSM-5 Severity Measure for Specific Phobia",
  // },
  // {
  //   value: "PSS",
  //   label: "Perceived Stress Scale",
  // },
  // {
  //   value: "WSS",
  //   label: "The Workplace Stress Scale",
  // },
  // {
  //   value: "PSWQ",
  //   label: "Penn State Worry Questionnaire",
  // },
  // {
  //   value: "PSWQ-C",
  //   label: "Penn State Worry Questionnaire - Child",
  // },
  // {
  //   value: "AAS",
  //   label: "Adult Attachment Scale",
  // },
  // {
  //   value: "SAAM",
  //   label: "State Adult Attachment Measure",
  // },
  // {
  //   value: "EQ",
  //   label: "Empathy Quotient",
  // },
  // {
  //   value: "AQ",
  //   label: "Autism Spectrum Quotient",
  // },
  // {
  //   value: "CAST",
  //   label: "Childhood Autism Spectrum Test - Parent",
  // },
  // {
  //   value: "RAADS-14",
  //   label: "Ritvo Autism & Asperger Diagnostic Scale",
  // },
  // {
  //   value: "MAYSI",
  //   label: "Massachusetts Youth Screening Inventory",
  // },
  // {
  //   value: "BDRS",
  //   label: "Bipolar Depression Rating Scale (Clinician Administered)",
  // },
  // {
  //   value: "MDQ",
  //   label: "Mood Disorder Questionnaire",
  // },
  // {
  //   value: "MSI-BPD",
  //   label: "McLean Screening Instrument for Borderline Personality Disorder",
  // },
  // {
  //   value: "NQ",
  //   label: "Nijmegen Questionnaire",
  // },
  // {
  //   value: "OLBI",
  //   label: "Oldenburg Burnout Inventory",
  // },
  // {
  //   value: "Child Behavior Rating Scale (CBRS)",
  //   label: "Child Behavior Rating Scale",
  // },
  // {
  //   value: "BMS Evaluation of Session",
  //   label: "Brief Mood Survey Evaluation of Therapy Session",
  // },
  // {
  //   value: "Satisfaction With Care",
  //   label: "Satisfaction With Care",
  // },
  // {
  //   value: "SF CDS",
  //   label: "Spann-Fischer Codependency Scale",
  // },
  // {
  //   value: "FBS",
  //   label: "Friedman Belief Scale",
  // },
  // {
  //   value: "FBS-N",
  //   label: "Friedman Belief Scale - Negative",
  // },
  // {
  //   value: "FBS-P",
  //   label: "Friedman Belief Scale - Positive",
  // },
  // {
  //   value: "BBQ",
  //   label: "Questionnaire for Assessing Blocking Beliefs",
  // },
  // // {
  // //   value: "CS",
  // //   label: "Compassion Scale",
  // // },
  // // {
  // //   value: "CS",
  // //   label: "Compassion Scale-D",
  // // },
  // // {
  // //   value: "CS",
  // //   label: "Compassion Scale-D",
  // // },
  // {
  //   value: "CS",
  //   label: "Compassion Scale-D",
  // },
  // {
  //   value: "ACSI",
  //   label: "Athletic Coping Skills Inventory",
  // },
  // {
  //   value: "FAAS NEW",
  //   label: "Fondness and Admiration System",
  // },
  // {
  //   value: "LOVEMAP",
  //   label: "Love Maps",
  // },
  // {
  //   value: "MSI",
  //   label: "Weiss-Cerreto Marital Status Inventory",
  // },
  // {
  //   value: "COVID-19 Screener",
  //   label: "COVID-19 Screener",
  // },
  // {
  //   value: "DSRS",
  //   label: "DIAMOND Self Report Screener",
  // },
  // {
  //   value: "MCSI",
  //   label: "Modified Colorado Symptom Index",
  // },
  // {
  //   value: "PSTQ",
  //   label: "Psychiatric Symptom & Treatment Questionnaire",
  // },
  // {
  //   value: "PSTQ-A",
  //   label: "Psychiatric Symptom & Treatment Questionnaire (Alliance Only)",
  // },
  // {
  //   value: "DGSR",
  //   label: "Dietitian General Symptom Report",
  // },
  // {
  //   value: "DTS",
  //   label: "Distress Tolerance Scale",
  // },
  // {
  //   value: "DBT-WCCL",
  //   label: "DBT Ways of Coping Checklist",
  // },
  // // {
  // //   value: "CES-DC",
  // //   label: "Center for Epidemiological Studies Depression Scale for Children",
  // // },
  // {
  //   value: "CES-DC",
  //   label: "Center for Epidemiological Studies Depression Scale for Children",
  // },
  // {
  //   value: "CES-D",
  //   label: "Center for Epidemiologic Studies Depression Scale",
  // },
  // {
  //   value: "DSM-5 II-Dep-P",
  //   label: "DSM-5 Level 2 Depression, Parent Report",
  // },
  // {
  //   value: "MADRS-S",
  //   label: "Montgomery-Åsberg Depression Rating Scale - Self-report",
  // },
  // {
  //   value: "SMFQ",
  //   label: "Mood and Feelings Questionnaire - Child Short",
  // },
  // {
  //   value: "ODSIS",
  //   label: "Overall Depression Severity and Impairment Scale ",
  // },
  // {
  //   value: "PHQ 8",
  //   label: "Patient Health Questionnaire-8",
  // },
  // {
  //   value: "PHQ-9 + Impairment",
  //   label: "Patient Health Questionnaire-9 + Functional Impairment",
  // },
  // {
  //   value: "PHQ-A",
  //   label: "Patient Health Questionnaire for Adolescents",
  // },
  // {
  //   value: "PHQ-9 (Spanish)",
  //   label: "Patient Health Questionnaire - Spanish",
  // },
  // {
  //   value: "PROMIS Depressive Symptoms - Parent Report",
  //   label: "PROMIS Parent Proxy Depressive Symptoms - Short Form 6a V2",
  // },
  // {
  //   value: "DASS-Y",
  //   label: "Depression Anxiety and Stress Scale, Youth",
  // },
  // {
  //   value: "DASS",
  //   label: "Depression Anxiety Stress Scales",
  // },
  // {
  //   value: "DASS-10",
  //   label: "Depression Anxiety Stress Scales - 10",
  // },
  // {
  //   value: "AC-OK",
  //   label: "Adult Screen for Co-occurring Disorders",
  // },
  // // {
  // //   value: "BPDS",
  // //   label: "Blueprint Diagnostic Screener",
  // // },
  // {
  //   value: "BPDS",
  //   label: "Blueprint Diagnostic Screener (<18)",
  // },
  // {
  //   value: "DSM5-CCSM",
  //   label: "DSM-5 Cross-Cutting Symptom Measure",
  // },
  // {
  //   value: "DSM-5 Level 1 Child",
  //   label: "DSM-5 Cross-Cutting Symptom Measure— Child Age 11–17",
  // },
  // {
  //   value: "DSM-5 Level 1 Parent",
  //   label: "DSM-5 Cross-Cutting Symptom Measure, Parent/Guardian Report",
  // },
  // {
  //   value: "CDC",
  //   label: "Child Dissociative Checklist",
  // },
  // {
  //   value: "A-DES",
  //   label: "Dissociative Experiences Scale - Adolescent",
  // },
  // {
  //   value: "DES-B NEW",
  //   label: "Dissociative Experiences Scale- Brief (DES-B)",
  // },
  // {
  //   value: "DES",
  //   label: "Dissociative Experiences Scale II",
  // },
  // {
  //   value: "DRS",
  //   label: "Dissociative Regression Scale",
  // },
  // {
  //   value: "DRS-CA",
  //   label: "Dissociative Regression Scale, Child/Adolescent",
  // },
  // {
  //   value: "DSM-5 SMD-C",
  //   label: "DSM-5 Severity Measure for Dissociation, Child",
  // },
  // {
  //   value: "DSS-B",
  //   label: "Brief Dissociative Symptoms Scale",
  // },
  // {
  //   value: "DSS",
  //   label: "Dissociative Symptoms Scale",
  // },
  // {
  //   value: "MAIA-2",
  //   label: "Multidimensional Assessment of Interoceptive Awareness",
  // },
  // {
  //   value: "YFAS 2.0",
  //   label: "Yale Food Addiction Scale 2.0",
  // },
  // {
  //   value: "EAT-26 Part B",
  //   label: "Eating Attitudes Test",
  // },
  // {
  //   value: "BES",
  //   label: "Binge Eating Scale",
  // },
  // {
  //   value: "IES-2",
  //   label: "Intuitive Eating Scale-2",
  // },
  // {
  //   value: "QEWP-R",
  //   label: "Questionnaire on Weight and Eating Patterns-Revised",
  // },
  // {
  //   value: "SBC",
  //   label: "Scale of Body Connection",
  // },
  // {
  //   value: "YFAS",
  //   label: "Yale Food Addiction Scale",
  // },
  // {
  //   value: "BDSS",
  //   label: "Body Dysmorphic Symptoms Scale ",
  // },
  // {
  //   value: "CIA 3.0",
  //   label: "Clinical Impairment Assessment Questionnaire",
  // },
  // {
  //   value: "EDE-QS",
  //   label: "Eating Disorder Examination-Questionnaire - Short",
  // },
  // {
  //   value: "SCOFF",
  //   label: "The SCOFF Questionnaire",
  // },
  // {
  //   value: "EDQOL",
  //   label: "Eating Disorders Quality of Life Questionnaire",
  // },
  // {
  //   value: "EDE-Q 6.0 (modified)",
  //   label: "Eating Disorder Examination Questionnaire",
  // },
  // {
  //   value: "MHC-SF",
  //   label: "Adolescent Mental Health Continuum-Short Form",
  // },
  // {
  //   value: "DERS-18",
  //   label: "Difficulties in Emotion Regulation Scale-18 item",
  // },
  // {
  //   value: "DERS",
  //   label: "Difficulties in Emotion Regulation Scale 36",
  // },
  // {
  //   value: "ERQ",
  //   label: "Emotion Regulation Questionnaire",
  // },
  // {
  //   value: "SPS NEW",
  //   label: "Skin Picking Scale",
  // },
  // {
  //   value: "SCORE-15 Kids",
  //   label: "Systematic Clinical Outcome and Routine Evaluation 15",
  // },
  // {
  //   value: "SCORE-15",
  //   label: "Systematic Clinical Outcome and Routine Evaluation 15 Adult",
  // },
  // {
  //   value: "FAD",
  //   label: "McMaster Family Assessment Device",
  // },
  // {
  //   value: "FWBS",
  //   label: "CFPB Financial Well-Being Scale",
  // },
  // {
  //   value: "CFARS",
  //   label: "Childrens Functional Assessment Rating Scale",
  // },
  // {
  //   value: "TCS NEW",
  //   label: "Transgender Congruence Scale",
  // },
  // {
  //   value: "GQI- NEW",
  //   label: "Genderqueer Identity Scale",
  // },
  // {
  //   value: "GCLS - Psy",
  //   label:
  //     "Gender Congruence and Life Satisfaction Scale - Psychological Functioning Subscale",
  // },
  // {
  //   value: "AYR",
  //   label: "Are You Ready?",
  // },
  // {
  //   value: "CGA",
  //   label: "Complicated Grief Assessment ",
  // },
  // {
  //   value: "GIS",
  //   label: "Grief Intensity Scale",
  // },
  // {
  //   value: "ICG",
  //   label: "Inventory of Complicated Grief",
  // },
  // {
  //   value: "TGI-SR+",
  //   label: "Traumatic Grief Inventory – Self Report Plus",
  // },
  // {
  //   value: "GS",
  //   label: "Grit Scale",
  // },
  // {
  //   value: "MGMA",
  //   label: "Modified Growth Mindset Assessment",
  // },
  // {
  //   value: "OHQ NEW",
  //   label: "Oxford Happiness Questionnaire",
  // },
  // {
  //   value: "NIH-HEALS",
  //   label: "NIH-Healing Experience in All Life Stressors",
  // },
  // {
  //   value: "BVS NEW",
  //   label: "Body Vigilance Scale",
  // },
  // {
  //   value: "MHLC-C",
  //   label: "Multidimensional Health Locus of Control - Form C",
  // },
  // {
  //   value: "AHS",
  //   label: "Adult Hope Scale",
  // },
];

// cc.reduce((acc,cur,ind)=>{
//     const  cob=cc[ind]
//     const section=cob.content.sections?.[0]

//      const answers=(section.answers?.length>0?section.answers:section.questions?.[0].answers).reduce((acc,cur)=>{
//         acc[cur.title]=cur.value

//         return acc;
//     },{})
//     const qns=section.questions.map((it)=>({uuid:it.title+it.key,title:it.title}))

//     const valObj={title:section.title,answersOptions:answers,questions:qns}

//     // const newObj={[cob.content.display_name]:valObj}
//     acc[cob.content.display_name]={
//     id: cob.id,
//     assessment_id:cob.assessment_id,
//     AssessmentName:cob.full_name,
//     total_score: 0,
//     section:valObj}

//     return acc;
// },{})
